import { useI18n } from '@cascade/react/i18n';
import { Button, Dialog, TextArea } from '@cascade/ui-library';
import { useState } from 'react';
import classes from './ReasonDialog.module.scss';
import type { TReasonDialogProps } from './ReasonDialog.types.ts';

export const ReasonDialog = ({
  title,
  description,
  submitLabel,
  minLength,
  isPending,
  onSubmit,
  onClose,
}: TReasonDialogProps) => {
  const { translate } = useI18n();
  const [reason, setReason] = useState('');

  const trimmedReason = reason.trim();
  const canSubmit = trimmedReason.length >= minLength && !isPending;

  const submit = () => onSubmit(trimmedReason);

  return (
    <Dialog
      open
      size='sm'
      title={title}
      subtitle={description}
      footer={
        <div className={classes.actions}>
          <Button
            variant='secondary'
            label={translate('ticket.reason.cancel')}
            disabled={isPending}
            onClick={onClose}
          />
          <Button
            variant='primary'
            label={submitLabel}
            disabled={!canSubmit}
            onClick={submit}
          />
        </div>
      }
      onClose={onClose}
    >
      <TextArea
        label={translate('ticket.reason.label')}
        placeholder={translate('ticket.reason.placeholder')}
        value={reason}
        rows={3}
        resize='none'
        disabled={isPending}
        onChange={setReason}
      />
    </Dialog>
  );
};
